import React from 'react';
import _ from 'lodash';

import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
export const SocialProfilesBasicInfoComponent = ({
    selectedSocialProfiles,
    handleInnerFormChange,
    socialProfileType,policyOwnerType,accountTypesListLoading,accountTypesList,accountListLoading,accountsList

}: any) => {


    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="SocialProfile Type"
                            labelField="Text"
                            list={socialProfileType}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SocialProfileTypeId'
                                )
                            }}
                            optionName='Choose SocialProfile Type'
                            type="select"
                            value={selectedSocialProfiles?.SocialProfileTypeId}
                            valueField="Value"
                        />

                        <InputContainer
                            label="Name"
                            name="Name"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                )
                            }}
                            type="text"
                            value={selectedSocialProfiles?.Name}
                        />

                        <InputContainer
                            label="SocialProfile Url"
                            name="SocialProfileUrl"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SocialProfileUrl'
                                )
                            }}

                            type="text"
                            value={selectedSocialProfiles?.SocialProfileUrl}
                        />

                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Description'
                                )
                            }}
                            type="text"
                            value={selectedSocialProfiles?.Description}
                        />
                        <InputContainer
                            label="Level"
                            labelField="Text"
                            list={policyOwnerType}
                            isDisabled={selectedSocialProfiles?.Id && selectedSocialProfiles?.OwnerLevelId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerLevelId'
                                );
                            }}
                            optionName='Choose Level'
                            type="select"
                            value={selectedSocialProfiles?.OwnerLevelId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Account Type"
                            labelField="Name"
                            isLoading={accountTypesListLoading}
                            list={accountTypesList}
                            isDisabled={selectedSocialProfiles?.Id && selectedSocialProfiles?.OwnerTypeId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerTypeId',
                                );
                            }}
                            optionName='Choose Account Type'
                            type="select"
                            value={selectedSocialProfiles?.OwnerTypeId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Account Name"
                            labelField="Name"
                            isLoading={accountListLoading}
                            list={accountsList}
                            isDisabled={selectedSocialProfiles?.Id && selectedSocialProfiles?.OwnerAccountId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerAccountId',
                                );
                            }}
                            optionName='Choose Account Name'
                            type="select"
                            value={selectedSocialProfiles?.OwnerAccountId}
                            valueField="Id"
                        />
                    </div>
                }
                expandedPanel="basicInfo"
                headerTitle="Basic Info"
            />
        </>
    );
};
export default SocialProfilesBasicInfoComponent;
